module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iYf5W"))).then(() => module.bundle.root('hEqeo'));